import { StyleSheet as PDFStyleSheet } from '@react-pdf/renderer'

const styles = PDFStyleSheet.create({
  mainDiv: {
    position: 'relative',
    width: '90%',
    borderWidth: 1,
    borderColor: '#dbdbdb',
    borderRadius: 8,
    marginTop: 28
  },
  priceTitleContainer: {
    position: 'absolute',
    backgroundColor: '#ffffff',
    width: '100%',
    flexDirection: 'row',
    left: 0,
    top: -18
  },
  // Statement layout: one line per amount, label left, signed amount right.
  statement: {
    width: '100%',
    paddingHorizontal: 16,
    paddingVertical: 8
  },
  line: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 3
  },
  totalLine: {
    borderTopWidth: 1,
    borderColor: '#bdbdbd',
    marginTop: 4,
    paddingTop: 6
  },
  lineLabel: { fontSize: 9, color: '#555555' },
  totalLabel: { fontSize: 10, color: '#000000', fontWeight: 'bold' },
  amount: { width: 160, textAlign: 'right' },
  lineAmount: { fontSize: 9, color: '#000000' },
  discountAmount: { fontSize: 9, color: '#2e7d32' },
  penaltyAmount: { fontSize: 9, color: '#c62828' },
  totalAmount: { fontSize: 10, color: '#000000', fontWeight: 'bold' },
  subtitle: {
    fontSize: 10,
    color: 'black'
  }
})

export default styles
